import React from 'react';
import Layout from '../../../components/Layout';
import ServicesLayout from '../../../components/ServicesLayout';
import AvailableServices from './AvailableServices';


import { isAdminUser } from '../../../lib/utils';

const title = 'Zarządzanie Urzędami';

export default {

  path: '/available_services',
  children: [
    {
      path: '/',
      async action(ctx) {
        const isAdmin = await isAdminUser(ctx);
        if (!isAdmin) {
          return { redirect: '/' };
        }
        return {
          title,
          chunk: 'AvailableServices',
          component: <ServicesLayout isAdmin><AvailableServices title={title}/></ServicesLayout>,
        };
      },
    },
    require('./add_availableservices').default,
    require('./edit_availableservice').default,
  ],
};



// WEBPACK FOOTER //
// src/routes/admin/available_services/index.js